// extracted by mini-css-extract-plugin
export default {"heading":"Wk-z","signin":"Xk-z","signupBtn":"Yk-z","disabled":"Zk-z"};